import type { ReactNode } from "react";

/**
 * O fundo azul da marca, com o brilho radial no topo.
 *
 * Existe como componente por um motivo só: o login e o hub são a MESMA tela do
 * ponto de vista de quem entra — o logo do login sobe e vira o logo do hub. Se
 * o azul ou o brilho divergirem entre os dois arquivos, a transição vira um
 * corte visível. Um lugar, dois usos.
 *
 * #354660 é o azul da marca, o mesmo do menu.
 */
export const FundoMarca = ({
  children,
  className = "",
  cor,
}: {
  children: ReactNode;
  className?: string;
  /** Cor do escritório cliente (migration 279) no lugar do azul da North. */
  cor?: string | null;
}) => (
  <div
    // `relative` porque o hub ancora o botão de sair no canto.
    className={`relative flex min-h-screen flex-col items-center justify-center bg-[#354660] p-6 ${className}`}
    style={{
      ...(cor ? { backgroundColor: cor } : {}),
      backgroundImage:
        "radial-gradient(ellipse 80% 55% at 50% 0%, rgba(255,255,255,0.10), transparent 70%)",
    }}
  >
    {children}
  </div>
);

/** O logo branco da marca. Mesmo arquivo no login e no hub, pra não piscar. */
export const LOGO_MARCA = "/logos/logo-mark-white.png";
